<template>
  <div class="schoolDetailsWrap">
    <div class="bg">
      <div class="bgImg">
        <div class="pageTitle">学校简介</div>
        <img src="@/assets/img/bjing@2x.png" alt="" />
      </div>
    </div>
    <div class="schoolDetails" v-if="!isLoading">
      <!-- <div v-if="detailsInfo.id" class="schoolInfo" v-html="detailsInfo.newsContent">
      </div>
      <div v-else class="noData">暂无数据</div> -->
      <div class="detailTitle">{{ detailsInfo.orgName ? detailsInfo.orgName : '暂无' }}</div>
      <div class="detailteacherintro">发布日期：{{ detailsInfo.createTime ? detailsInfo.createTime : '暂无' }}</div>
      <div>
        <p class="Title">分校办学基础情况</p>
        <div  class="content_html" v-html="detailsInfo.orgInfo ? detailsInfo.orgInfo : '暂无'"></div>
      </div>
      <div>
        <p class="Title">分校环境</p>
        <div  class="content_html" v-html="detailsInfo.orgCampus ? detailsInfo.orgCampus : '暂无'"></div>
      </div>
      <div>
        <p class="Title">办学特色与优势</p>
        <div  class="content_html" v-html="detailsInfo.orgAdvantage ? detailsInfo.orgAdvantage : '暂无'"></div>
      </div>
      <div>
        <p class="Title">联系人</p>
        <div  class="content_html" v-html="detailsInfo.orgUser ? detailsInfo.orgUser : '暂无'"></div>
      </div>
      <div>
        <p class="Title">联系方式</p>
        <div class="content_html"  v-html="detailsInfo.orgTel ? detailsInfo.orgTel : '暂无'"></div>
      </div>
      <div>
        <p class="Title">地址</p>
        <div class="content_html" v-html="detailsInfo.orgAddr ? detailsInfo.orgAddr : '暂无'"></div>
      </div>
      <div>
        <p class="Title">网址</p>
        <div class="content_html"  v-html="detailsInfo.orgWebsite ? detailsInfo.orgWebsite : '暂无'"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNewsByIdm, couschoolGetBranchIntroductionByOrgId } from '@/api/schoolInfo'
export default {
  name: "schoolDetails",
  data() {
    return {
      isLoading: true,
      detailsInfo: {}
    };
  },
  created() {
    this.initRequest()
  },
  methods: {
    initRequest() {
      couschoolGetBranchIntroductionByOrgId({ orgId: this.$route.query.id }).then(res => {
        this.detailsInfo = res
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
      })
    }
  },
};
</script>
<style scoped>
.schoolDetailsWrap {
  position: relative;
}

/* 背景图片 */
.bgImg {
  position: relative;
  width: 100%;
  height: 272px;
  z-index: 0;
}

.bgImg img {
  width: 100%;
  height: 100%;
}

.bgImg .pageTitle {
  position: absolute;
  top: 82px;
  left: 26px;
  font-size: 25px;
  font-weight: bold;
  color: #FFFFFF;
}

.schoolInfo {
  box-sizing: border-box;
  position: absolute;
  top: 138px;
  width: calc(100vw - 20px);
  margin: 0 10px;
  padding: 24px 18px;
  background: #fff;
  border-radius: 7px 7px 7px 7px;
}

/deep/img {
  max-width: 100%;
}

.noData {
  width: 100%;
  line-height: 100px;
  text-align: center;
  font-weight: bold;
}

.Title {
  font-size: 16px;
  font-weight: bold;
  padding: 10px 0px;
}

.detailTitle {
  text-align: center;
  font-size: 2rem;

}

.detailteacherintro {
  padding-top: 1rem;
  text-align: center;
}
.content_html{
  text-indent: 2em;
}
.schoolDetails{
  padding: 10px;
}
</style>